"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushEvent = void 0;
const dataLayer_1 = __importDefault(require("@ocm/services/dataLayer"));
const store_1 = require("@/state/store");
function pushEvent(action, label = "") {
    const prefix = "S_";
    const category = getEventCategory();
    const eventObj = {
        event: "GAevent",
        event_category: `${prefix}${category}`,
        event_action: `${prefix}${action}`,
        event_label: label ? `${prefix}${label}` : "",
    };
    (0, dataLayer_1.default)(eventObj);
}
exports.pushEvent = pushEvent;
function getEventCategory() {
    const type = (store_1.store.isLogin && "Login") || "Registration";
    const form = (!store_1.store.isLandingPage && "Layer") || "Form";
    return (store_1.store.isLastStepPage && "RegisterConfirmation") || `${type}${form}`;
}
